export default __webpack_public_path__ + "static/media/2049.a86a7b22.png";